var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wallet-workpackage font-weight-light",style:(_vm.selected?`
  position: fixed;
  padding: 10px 0px 10px 0px;
  top: ${_vm.$vuetify.breakpoint.smAndDown?'30px':'78px'};
  z-index: 1;
  width: ${!_vm.$vuetify.breakpoint.smAndDown?
    'calc((100vw - 50px) / 3 - 20px)':
    'calc(100vw - 20px)'
  }
  `:`
  z-index: 0;
  width: ${!_vm.$vuetify.breakpoint.smAndDown?
    'calc((100vw - 50px) / 3 - 20px)':
    'calc(100vw - 20px)'
  }
  `)},[_c('div',{class:`wallet-workpackage-header-slot${_vm.selected}${_vm.other_selected}`},[_vm._t("header",null,{"twork_package":_vm.twork_package,"previous_twork_package":_vm.previous_twork_package})],2),_c('div',{class:`wallet-workpackage-body-slot${_vm.selected}${_vm.other_selected}`},[_vm._t("body",null,{"twork_package":_vm.twork_package})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }